/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_New_Account_KbInputs */

const en_signin_new_account_kb = /** @type {(inputs: Signin_New_Account_KbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No account yet? The same button creates one.`)
};

const id_signin_new_account_kb = /** @type {(inputs: Signin_New_Account_KbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum punya akun? Tombol yang sama sekaligus membuatnya.`)
};

/**
* | output |
* | --- |
* | "No account yet? The same button creates one." |
*
* @param {Signin_New_Account_KbInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const signin_new_account_kb = /** @type {((inputs?: Signin_New_Account_KbInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_New_Account_KbInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_signin_new_account_kb(inputs)
	return en_signin_new_account_kb(inputs)
});